export default {
  "header": {
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About"])},
    "log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login / Register"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
    "manage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
    "music": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Music"])}
  },
  "home": {
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start listening to the best new releases."])},
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listen to Great Music !"])}
  },
  "mainContent": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Songs"])}
  },
  "mySongs": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Songs"])}
  },
  "sondDetails": {
    "comments": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No Comments"]), _normalize(["1 Comment"]), _normalize([_interpolate(_named("count")), " Comments"])])}
  },
  "upload": {
    "drop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drop your files here"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload"])}
  }
}